import { useOutletContext } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Founders from "@/components/Founders";
import Daisy from "@/components/Daisy";
import Services from "@/components/Services";
import Work from "@/components/Work";
import Contact from "@/components/Contact";

export default function Landing() {
  const { introDone } = useOutletContext();
  return <><Hero ready={introDone} /><Marquee /><Work /><Services /><Founders /><Daisy /><Contact /></>;
}